const config = {
  coverSuffix: '-newslist7.0.4', // "-newslistnormal61", -smallimage3G
  coverBigSuffix: '', // "-newslistbig6", -bigimage4G
  AppID: "wx89cd743f8cdc3eec",
  wsStatisUrl: 'https://wscdn.ql1d.com',
}

export default config



// WEBPACK FOOTER //
// ./src/common/js/config.js